import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import type { DrawerProps } from '@mui/material/Drawer';
import Drawer from '@mui/material/Drawer';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';

export default function DrawerWithCloseIcon({
  open,
  onClose,
  children,
  anchor,
}: {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  anchor?: DrawerProps['anchor'];
}) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ sx: { minWidth: '90%', overflow: 'hidden' } }}
      anchor={anchor}
    >
      <Grid container justifyContent="flex-end" py={1} px={2}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Divider />
      {children}
    </Drawer>
  );
}
